import { render } from "./HelpDeskPortal.vue?vue&type=template&id=1d2ece24"
import script from "./HelpDeskPortal.vue?vue&type=script&lang=js"
export * from "./HelpDeskPortal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__